module.exports = __webpack_public_path__ + "img/measurement-empty.6ffd1628.svg";